import eventObject from '#frontend/dtm/shared/event.js';

export default (cart) => ({
	event_type: 'cartview',
	avast_distributor: cart.theme.provider.name || 'NA',
	...eventObject(cart, ['product_id']) // Get requested product data
});
